export const CASES = [
  {
    slug: "fastfood",
    no: "01",
    title: "Burger Basen",
    category: "Fastfood",
    description:
      "En rap og appetitlig bestillingsside med menu, priser og afhentning — bygget til at få sultne kunder hurtigt fra klik til burger.",
    demo: true,
    image:
      "https://images.unsplash.com/photo-1568901346375-23c9450c58cd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwxfHxidXJnZXIlMjBmYXN0JTIwZm9vZCUyMHJlc3RhdXJhbnR8ZW58MHx8fHwxNzg4MDE1NjU5fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    slug: "toejbutik",
    no: "02",
    title: "Atelier Nord",
    category: "Tøjbutik",
    description:
      "Et minimalistisk mode-univers med kollektioner, lookbook-stemning og en shop-oplevelse der føles som et fysisk atelier.",
    demo: true,
    image:
      "https://images.unsplash.com/photo-1567401893414-76b7b1e5a7a5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwzfHxmYXNoaW9uJTIwY2xvdGhpbmclMjBzdG9yZXxlbnwwfHx8fDE3ODgwMTU2NTl8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    slug: "hygge-tavern",
    no: "03",
    title: "Den Hyggelige Taverna",
    category: "Hygge-tavern",
    description:
      "Varm stemning, levende lys og bordbooking — en side der dufter af træ, fadøl og gode historier allerede på skærmen.",
    demo: true,
    image:
      "https://images.unsplash.com/photo-1692455129272-60299bc2b1a8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHw0fHxjb3p5JTIwdGF2ZXJuJTIwYmFyfGVufDB8fHx8MTc4ODAxNTY1OXww&ixlib=rb-4.1.0&q=85",
  },
  {
    slug: "laege-support",
    no: "04",
    title: "LægeSupport",
    category: "Læge-support",
    description:
      "Rolig, tillidsvækkende og klinisk præcis — tidsbestilling og patientinformation samlet ét trygt sted.",
    demo: true,
    image:
      "https://images.unsplash.com/photo-1758691461935-202e2ef6b69f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzN8MHwxfHNlYXJjaHw0fHxtZWRpY2FsJTIwY2xpbmljJTIwZG9jdG9yfGVufDB8fHx8MTc4ODAxNTY1OXww&ixlib=rb-4.1.0&q=85",
  },
  {
    slug: "klart-syn",
    no: "05",
    title: "Klart-syn",
    category: "Vinduespudser",
    description:
      "Krystalklare ruder og online booking — en frisk side der får kalenderen fyldt med både private og erhvervskunder.",
    demo: false,
    image: "https://images.unsplash.com/photo-1581578731548-c64695cc6952?q=85&w=1200",
  },
  {
    slug: "heights-care",
    no: "06",
    title: "Heights Care",
    category: "Facadeservice",
    description:
      "Reparation og vedligehold i højden, præsenteret tillidsvækkende med certificeringer og projektgalleri i centrum.",
    demo: false,
    image: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?q=85&w=1200",
  },
  {
    slug: "super-vvs",
    no: "07",
    title: "Super VVS",
    category: "VVS",
    description:
      "Akut hjælp døgnet rundt — vagttelefonen i fokus, tydelige priser og booking af tid på under et minut.",
    demo: false,
    image: "https://images.unsplash.com/photo-1585704032915-c3400ca199e7?q=85&w=1200",
  },
  {
    slug: "handyman-jan",
    no: "08",
    title: "Handyman Jan",
    category: "Handyman",
    description:
      "Én mand til alle småopgaver — en jordnær side med ydelsesliste, før/efter-eksempler og hurtig kontakt.",
    demo: false,
    image: "https://images.unsplash.com/photo-1621905251189-08b45d6a269e?q=85&w=1200",
  },
  {
    slug: "multi-clean",
    no: "09",
    title: "Multi-Clean Demo",
    category: "Rengøring",
    description:
      "Erhvervsrengøring med skræddersyede aftaler — en rolig, professionel side der sælger tryghed til virksomheder.",
    demo: false,
    image: "https://images.unsplash.com/photo-1603712725038-e9334ae8f39f?q=85&w=1200",
  },
  {
    slug: "craftpaint-studio",
    no: "10",
    title: "CraftPaint Studio",
    category: "Maler",
    description:
      "Farverådgivning og håndværk i fokus — et visuelt univers der viser finish, farvekort og referencer.",
    demo: false,
    image: "https://images.unsplash.com/photo-1562259949-e8e7689d7828?q=85&w=1200",
  },
  {
    slug: "hansen-menswear",
    no: "11",
    title: "Hansen Menswear",
    category: "Herretøj",
    description:
      "Klassisk herretøj med moderne webshop — skarpe produktbilleder og en elegant, maskulin stemning.",
    demo: false,
    image: "https://images.unsplash.com/photo-1617137968427-85924c800a22?q=85&w=1200",
  },
  {
    slug: "golden-bites",
    no: "12",
    title: "Golden Bites",
    category: "Bageri",
    description:
      "Surdejsbrød og søde sager med online bestilling — en varm side, der næsten dufter af nybagt.",
    demo: false,
    image: "https://images.unsplash.com/photo-1509440159596-0249088772ff?q=85&w=1200",
  },
  {
    slug: "craftwork-jan",
    no: "13",
    title: "Craftwork Jan",
    category: "Håndværk",
    description:
      "Håndværk med stolthed — projekter, referencer og hurtig kontakt samlet på én jordnær side.",
    demo: false,
    image: "https://images.unsplash.com/photo-1504148455328-c376907d081c?q=85&w=1200",
  },
  {
    slug: "kede-rooms",
    no: "14",
    title: "KEDE-Rooms",
    category: "KEDE Health Platform",
    description:
      "Rolige, lyse rum til restitution — booking og information om KEDE's opholdsrum samlet ét sted.",
    demo: false,
    image: "https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?q=85&w=1200",
  },
  {
    slug: "kede-water",
    no: "15",
    title: "KEDE-Water",
    category: "KEDE Health Platform",
    description:
      "Rent vand som en del af sundheden — produktinfo og bestilling af KEDE's vandløsning.",
    demo: true,
    image: "https://images.unsplash.com/photo-1602143407151-7111542de6e8?q=85&w=1200",
  },
  {
    slug: "kede-cleaning",
    no: "16",
    title: "KEDE-Cleaning",
    category: "KEDE Health Platform",
    description:
      "Professionel rengøring med sundhed for øje — KEDE's rengøringskoncept præsenteret klart og enkelt.",
    demo: false,
    image: "https://images.unsplash.com/photo-1563453392212-326f5e854473?q=85&w=1200",
  },
  {
    slug: "kede-clothes",
    no: "17",
    title: "KEDE-Clothes",
    category: "KEDE Health Platform",
    description:
      "Funktionelt tøj til sundhed og hverdag — KEDE's tøjlinje præsenteret med webshop.",
    demo: false,
    image: "https://images.unsplash.com/photo-1523381210434-271e8be1f52b?q=85&w=1200",
  },
  {
    slug: "kede-juice",
    no: "18",
    title: "KEDE-Juice",
    category: "KEDE Health Platform",
    description:
      "Friskpresset juice med fokus på indhold og kvalitet — KEDE's juiceunivers med online bestilling.",
    demo: true,
    image: "https://images.unsplash.com/photo-1610970881699-44a5587cabec?q=85&w=1200",
  },
  {
    slug: "kede-mobile-juice",
    no: "19",
    title: "KEDE-mobile-Juice",
    category: "KEDE Health Platform",
    description:
      "Juice på hjul — KEDE's mobile juicebar til events og markeder, med booking og menukort.",
    demo: false,
    image: "https://images.unsplash.com/photo-1600271886742-f049cd451bba?q=85&w=1200",
  },
  {
    slug: "kede-internet",
    no: "20",
    title: "KEDE-Internet",
    category: "KEDE Health Platform",
    description:
      "Stabil internetadgang som en del af sundhedsplatformen — KEDE's internetløsning forklaret enkelt.",
    demo: false,
    image: "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?q=85&w=1200",
  },
];

export const PORTRAIT_URL =
  "https://images.unsplash.com/photo-1506863530036-1efeddceb993?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHwxfHxjcmVhdGl2ZSUyMHByb2Zlc3Npb25hbCUyMHBvcnRyYWl0fGVufDB8fHx8MTc4ODAxNTY3MXww&ixlib=rb-4.1.0&q=85";
